window['eventConfig'] = window['EVENT_CONFIG'];
